import {
  Address,
  BuildingLevel,
  BuildingType,
  PolicyIssued,
  SumInsuredType,
  ValueRange,
  YesNoAnswer,
  CoverType,
} from 'scenes/common/types';

export enum LandlordQuoteSubSection {
  MainAddress = 'Main address',
  PropertyOwnership = 'Property ownership',
  PropertyPurpose = 'Property purpose',
  RentalAgreement = 'Rental agreement',
  WeeklyRent = 'Weekly rent',
  UsedForBusiness = 'Used for business',
  // eslint-disable-next-line no-shadow
  BuildingType = 'Building type',
  RecentInsurer = 'Recent insurer',
  YearsInsured = 'Years insured',
  ClaimsMade = 'Claims made',
  BreakIn = 'Break in',
  AdditionalSecurity = 'Additional security',
  NumberOfBedrooms = 'Number of bedrooms',
  PropertyBuiltYear = 'Property built year',
  CertificateOfOccupancy = 'Certificate of occupancy',
  RoofMaterial = 'Roof material',
  WallMaterial = 'Wall material',
  SecurityFeatures = 'Security features',
  PolicyStartDate = 'Policy start date',
  FlybuysNumber = 'Flybuys number',
  BuildingSumInsuredChoice = 'Building sum insured choice',
  BuildingAgreedSumInsured = 'Building agreed sum insured',
  IssuedToPersonOrBusiness = 'Policy issued to person or business',
  ContentsSumInsured = 'Contents sum insured',
  ContactDateOfBirth = 'Contact date of birth',
}

export enum CoverTypeQueryParam {
  Contents = 'Contents',
  HomenCon = 'HomenCon',
  Home = 'Home',
}

export enum PropertyPurposeType {
  Unspecified = '',
  PPR = 'Live in it as your home',
  HolidaysHouse = "Spend some time there but it's not your main home",
  Rental = 'Rent it out',
  ShortTermRental = 'Rent it out as a short term or holiday rental property',
}

export enum KickOutChoice {
  Unspecified = '',
  ChangeOfMind = 'Change selection',
  StickWithTheChoice = 'Apply for Coles Home Insurance',
}

export interface LandlordQuoteData {
  prefilledCampaignId: string;
  prefilledPromoCode: string;
  colesCampaignCode: string;
  coverType: CoverType;
  policyStartDate: string;
  mainAddress: Address;
  ownedProperty: YesNoAnswer;
  purposeOfProperty: PropertyPurposeType;
  kickOutChoice: KickOutChoice;
  hasRentalAgreement: YesNoAnswer;
  weeklyRentPaid: string;
  propertyUsedForBusiness: YesNoAnswer;
  policyHolderDateOfBirth: string;
  businessOwnerDateOfBirth: string;
  recentInsurer: string;
  yearsInsured: number;
  claimsMade: number;
  policyIssued: PolicyIssued;
  buildingType: BuildingType;
  freestandingMetreGap: YesNoAnswer;
  freestandingStorey: YesNoAnswer;
  terraceStorey: YesNoAnswer;
  terraceStrata: YesNoAnswer;
  townhouseStorey: YesNoAnswer;
  townhouseStrata: YesNoAnswer;
  unitStorey: YesNoAnswer;
  unitLevel: BuildingLevel;
  unitStrata: YesNoAnswer;

  brokenInClaims: YesNoAnswer;
  additionalSecurityInstalled: YesNoAnswer;
  numberOfBedrooms: number;
  propertyBuiltYear: string;
  certificateOfOccupancy: YesNoAnswer;
  roofMaterial: string;
  wallMaterial: string;
  securityFeatures: string[];
  estimatedSumInsured: string;
  agreedSumInsuredRange: ValueRange;
  sumInsuredType: SumInsuredType;
  agreedBuildingSumInsured: string;
  contentsSumInsured: string;

  hasFlybuys: YesNoAnswer;
  flybuysNumber: string;
  promoCode: string;
}
